export default __webpack_public_path__ + "static/media/img_baseRattle_green_p.38efabcf.jpg";